import * as React from "react";

function SvgSurvicate(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        d="M120 59.993a29.99 29.99 0 00-30.003-29.99H120A30.005 30.005 0 0069.065 9.058a30.004 30.004 0 00-9.058 20.787V0a29.99 29.99 0 00-30.004 30.003V0a30.003 30.003 0 00-.145 59.993H0a29.99 29.99 0 0030.003 30.004H0a30.001 30.001 0 0029.925 29.45 30.005 30.005 0 0030.068-29.305V120a30.006 30.006 0 0029.99-30.003V120a30.006 30.006 0 0029.458-29.919 30.003 30.003 0 00-29.299-30.074h29.845l.013-.014zM60.007 89.851a29.977 29.977 0 00-29.845-29.844 29.99 29.99 0 0029.845-29.845A30.003 30.003 0 0089.85 60.007 29.99 29.99 0 0060.007 89.85z"
        fill="#171D1A"
      />
    </svg>
  );
}

export default React.forwardRef(SvgSurvicate);
